import { useTranslation } from 'next-i18next'
import { useState } from 'react'
import {
  FieldErrors,
  FieldValues,
  Path,
  UseFormRegister
} from 'react-hook-form'
import EyeHide from 'assets/icons/eye-hide.svg'
import EyeShow from 'assets/icons/eye-show.svg'
import { LogoFormClickableContainer } from 'components/Auth/AuthModal.style'
import { TextInput } from 'components/common/TextInput'
import { TextInputProps } from 'components/common/TextInput/TextInput'

type FormInputProps<TFormValues extends FieldValues> = {
  name: Path<TFormValues>
  register?: UseFormRegister<TFormValues>
  errors?: FieldErrors<TFormValues>
  customErrorMessage?: string
} & Omit<
  TextInputProps,
  'inputProps' | 'inputLabel' | 'errorMessage' | 'button'
>

export const PasswordInput = <TFormValues extends { password: string }>({
  name,
  register,
  errors,
  customErrorMessage,
  ...props
}: FormInputProps<TFormValues>) => {
  const [showPassword, setShowPassword] = useState(false)
  const { t } = useTranslation('authentication')
  const passwordError = errors?.password?.message
  return (
    <TextInput
      fullSize
      inputProps={{
        ...register?.(name),
        autoComplete: 'new-password',
        required: true,
        type: showPassword ? 'text' : 'password'
      }}
      inputLabel={t('login.form.password.label')}
      errorMessage={
        (typeof passwordError === 'string' ? passwordError : undefined) ??
        customErrorMessage
      }
      button={{
        type: 'button',
        disableEnterAction: true,
        noBackground: true,
        noBorder: true,
        label: (
          <LogoFormClickableContainer>
            {showPassword ? <EyeShow /> : <EyeHide />}
          </LogoFormClickableContainer>
        ),
        onClick: () => setShowPassword(!showPassword),
        style: {
          width: '24px',
          backgroundColor: '#FFFFFF00',
          marginLeft: '-34px'
        }
      }}
      {...props}
    />
  )
}
